import React, { useEffect, useState, useRef, useCallback } from "react";
import { MetaTags } from "../../Components/Layout/MetaTags.jsx";
import { Header } from "../../Components/Layout/Header.jsx";
import { ObavijestiCasino } from "../../Components/Layout/ObavijestiCasino.jsx";
import { GameDetails } from "../../Components/Game/GameDetails.jsx";
import { useHistory, useLocation } from "react-router-dom";


export default function ThemesPage(props) {
    const [height, setHeight] = useState(null);
    const iframeRef = useRef(null);
    const themeRef = useRef(null);
    const history = useHistory();
    const location = useLocation();
    const iframeSrc = useRef(`${casino.config.casinoModulesUrl}casino-themes`);
    const themeParam = new URLSearchParams(location.search).get("tema");

    useEffect(() => {
        if (themeParam) {
            themeRef.current = themeParam;
            sendTheme(themeParam);
        } else {
            sendTheme(null)
        }

        window.addEventListener("message", receiveMessages);

        return () => {
            window.removeEventListener("message", receiveMessages);
        }
    }, [themeParam])

    const sendTheme = useCallback((theme) => {
        if (iframeRef.current?.contentWindow) {
            iframeRef.current.contentWindow.postMessage({ type: "theme", theme }, "*");
            iframeRef.current.contentWindow.postMessage({ type: "darkMode", darkMode: casino.utils.getCasinoTheme() === "dark"}, "*");
        } else {
            console.error("iframe is not ready");
        }
    }, []);
   
    const receiveMessages = useCallback(
        (message) => {
            const { data } = message;

            if (data.type === "themesHeight") {
                setHeight(`${data.scrollHeight}px`);
            }

            if (data.type === "dialog") {
                const gameCode = data.params.sifra;
                const game = casino.casinoConstants.games.find((g) => g.s === gameCode);
                const brandName = casino.casinoConstants.brands[game.bID].nameNormalizirano;
                history.push(`/teme/game/${brandName}/${casino.utils.normalizeString(game.n)}?tema=${themeRef.current}`);
            }

            if (data.type === "urlParameter") {
                history.push(`/${data.urlParam}`);
                themeRef.current = data.urlParam
            }

            if (data.type == "themesReady") {
                sendTheme(themeParam);
                window.scrollTo(0, 0);
            }
        }, [history, themeParam]
    );

    const darkMode = localStorage.getItem("darkModeStrategy") || "light"

    return (
        <>
            <MetaTags
                title="Promocije - SuperSport CASINO"
                description="Casino Themes u SuperSport CASINU!"
            />
            <Header {...props} />
            <main id="Casino Themes" className={`themes-container${themeParam ? " theme" : ""} ${darkMode}`}>
                <iframe
                    ref={iframeRef}
                    title="SuperCasino Themes"
                    src={iframeSrc.current}
                    scrolling="no"
                    height={height}
                />
            </main>
            <GameDetails
                {...props}
                igre={casino.casinoConstants.games}
                routePrefix={`/teme?tema=${themeRef.current}`}
            />
            <ObavijestiCasino {...props} />
        </>
    );
}
